<template>
    <div class="login container-fluid p-0">
        <div class="row">
            <div class="col-lg-6 my-auto">
                <div class="img profileBg">
                    <img src="../../assets/images/loginBg.png" class="img-fluid" alt="Login Image">
                </div>
            </div>
            <div class="col-lg-6 bgBlue d-flex align-items-center justify-content-center p-0 m-0">
                <div class="card customizedCard">
                    <div class="card-body">
                        <h1 class="mb-4 loginTitle" >Hello, <br> Welcome back!</h1>
                        
                        <form @submit.prevent="onSubmit">
                            <label class="form-label">User Name  <span class="text-danger">*</span></label>
                            <Field name="userName" :rules="userNameRules" v-slot="{ field, errors }">
                                <input type="text" v-bind="field" class="form-control mb-3" placeholder="Enter your user name...">
                                <p class="text-danger">{{ errors[0] }}</p>
                            </Field>
                            <label class="form-label">Password  <span class="text-danger">*</span></label>
                            <Field name="password" :rules="passwordRules" v-slot="{ field, errors }">
                                <input type="password" v-bind="field" class="form-control mb-3" placeholder="Enter your password...">
                                <p class="text-danger">{{ errors[0] }}</p>
                            </Field>
                            <p class="forgetPassword" @click="navigateTo('/forgotPassword')">Forget password</p>
                            <button type="submit" class="btn btn-primary w-100">Login</button>
                        </form>
                        
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { allData } from '@/store/index';
import { toast } from 'vue3-toastify';
// import { ref } from 'vue'
import { useForm, Field } from 'vee-validate';
import { useRouter } from 'vue-router';
import * as yup from 'yup';
import axios from 'axios';
import useStorage from '@/mixins/GlobalMixins'
export default {
    name: 'LoginPage',
    setup() {
        const { setObjectToBase64, encodeString } = useStorage();
        const { handleSubmit } = useForm();
        const router = useRouter();
        const store = allData()
        // const users = ref(store.users)
        const notify = (msg, type) => {
            if(type == 'success'){
                toast.success(msg || 'Success!', {
                    autoClose: 3000,
                    position: 'top-right',
                });
            }
            else if(type == 'error'){
                toast.error(msg || 'Error!', {
                    autoClose: 3000,
                    position: 'top-right',
                });
            }
            
        };
        const navigateTo = (route) => {
            router.push(route);
        }
         // Define validation rules using Yup
        const userNameRules = yup.string().required('User Name is required')
        const passwordRules = yup.string().required('Password is required').min(4, 'Password must be at least 4 characters');

        const onSubmit = handleSubmit(async (values) => {
            if(values){
                try {
                    let response = await axios.post(`${process.env.VUE_APP_API_URL}/login`, {
                        userName: values.userName,
                        password: encodeString(values.password)
                    });
                    notify(response?.data?.message || 'Authentication verified. Redirecting...!', 'success');
                    let tempData = {
                        id: response?.data?.id,
                        userName: response?.data?.userName,
                        nickName: response?.data?.nickName,
                        userType: response?.data?.userType,
                        password: response?.data?.password,
                        phoneNumber: response?.data?.phoneNumber,
                        emailId: response?.data?.emailId
                    }
                    localStorage.setItem('token', response?.data?.token);
                    setObjectToBase64('userData', tempData)
                    // localStorage.setItem('userData', tempData);
                    store.updateProfileData(response?.data)
                    setTimeout(() => {
                        navigateTo('/')
                    }, 1000);
                } catch (err) {
                    notify(err?.response?.data?.message || 'User name or password is incorrect!', 'error')
                }
            }
        });

        return {
            allUsers: store.users,
            notify,
            navigateTo,
            userNameRules,
            passwordRules,
            onSubmit,
        }
    },
    components: {
        Field,
    },
}
</script>

<style>
.loginTitle{
    font-size: 2.5rem;
    font-weight: bold;
}
</style>